import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = "https://ggaarts.onrender.com/api";

const Section = ({ category, title, slogan, bgClass }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const rowRef = useRef(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/artworks`);
        const filtered = res.data.filter((a) => a.category === category);
        setItems(filtered);
      } catch (err) {
        console.log("Error loading:", err);
      }
      setLoading(false);
    };

    load();
  }, [category]);

  const scrollLeft = () => {
    rowRef.current?.scrollBy({ left: -400, behavior: "smooth" });
  };

  const scrollRight = () => {
    rowRef.current?.scrollBy({ left: 400, behavior: "smooth" });
  };

  return (
    <section className={`section section-bg ${bgClass}`}>
      <h2 className="new-section-heading">{title}</h2>
      {slogan && <p className="section-slogan">{slogan}</p>}

      <div className="slider-wrapper-main">
        <button className="slider-btn left" onClick={scrollLeft}>❮</button>

        <div className="slider-row" ref={rowRef}>
        {loading
  ? Array.from({ length: 5 }).map((_, i) => (
      <div className="art-card skeleton-card" key={i}>
        <div className="img-box skeleton-img shimmer"></div>
        <div className="skeleton-text shimmer"></div>
      </div>
    ))
            : items.map((item) => (
                <Link
                  to={`/artwork/${item._id}`}
                  className="art-link-wrapper"
                  key={item._id}
                >
                  <div className="art-card">

                    {item.category === "content_creators" ? (
                      <div className="price-tag-new not-sale-slider">
                        Not for Sale
                      </div>
                    ) : (
                      <div className="price-tag-new">₹{item.price}</div>
                    )}

                    <div className="img-box">
                      <img
                        src={item.image}
                        alt={item.name}
                        onError={(e) =>
                          (e.target.src =
                            "https://via.placeholder.com/300x200?text=No+Image")
                        }
                      />
                    </div>

                    <h3 className="card-title new-card-title">
                      {item.name}
                    </h3>
                  </div>
                </Link>
              ))}
        </div>

        <button className="slider-btn right" onClick={scrollRight}>❯</button>
      </div>
    </section>
  );
};

export default Section;
